module.exports = __webpack_public_path__ + "img/26.1913e7c7.png";